import { debounce } from "lodash";

function syncFrameHeightHandle() {
    if (window.parent) {
        const height = document.body.clientHeight;

        parent.postMessage({ height }, '*');
    }
}

function redirectLogin() {
    if(Config.login_page.substring(0, 3) === 'js:') {
        var message = Config.login_page.split(':', 2)[1];
        var pass_data = {'call_parent_function' : message};
        parent.postMessage(pass_data, "*");
    } else {
        window.top.location.href = Config.login_page;
    }
}

const syncFrameHeight = debounce(syncFrameHeightHandle, 100);

export { syncFrameHeight, redirectLogin};
